/**
 * @file sectionHeading.component.tsx
 * @path apps/website/src/components/common/sectionHeading.component.tsx
 * @description UI component
 */

export const SectionHeading = ({ children }: { children: React.ReactNode }) => (
  <h3 className="font-montserrat font-bold text-foreground mb-6 uppercase tracking-widest text-sm">
    {children}
  </h3>
);
